import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { TemplateModule } from './template/template.module';
import { TemplateService } from './shared/services/template.service';

// Layout Component
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';

// Routing Module
import { AppRoutes } from './app.routing';

// App Component
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { CoreModule } from './core/core.module';
import { DatePipe, DecimalPipe } from '@angular/common';
import { RedirectComponent } from './extras/redirect/redirect.component';

@NgModule({
  imports: [
    BrowserModule,
    //RouterModule.forRoot(),
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
    SharedModule,
    TemplateModule,
    CoreModule,
  ],
  declarations: [
    AppComponent,
    CommonLayoutComponent,
    AuthenticationLayoutComponent,
    AuthComponent,
    RedirectComponent,
  ],
  providers: [TemplateService, DecimalPipe, DatePipe],

  bootstrap: [AppComponent],
})
export class AppModule {}
/*function getSrv(name, element) {
    element = element || '*[ng-app]';
    return angular.element(element).injector().get(name);
}*/
